import { createRouter, createWebHistory } from 'vue-router'
import BigScreenLayout from '../layouts/BigScreenLayout.vue'
import IndustryMap from '../views/IndustryMap.vue'
import IndustryTalentMap from '@/views/IndustryTalentMap.vue'

const routes = [
  {
    path: '/',
    component: BigScreenLayout,
  
  },
  {
    path: '/industry-map',
    name: 'IndustryMap',
    component: IndustryMap
  },
  {
    path: '/industry-talent-map',
    name: 'IndustryTalentMap',
    component: IndustryTalentMap
  },
  {
    path: '/zhongdian-tupu',
    name: 'ZhongdianTupu',
    component: () => import('@/views/ZhongdianTupu.vue')
  },
  {
    path: '/xiangshan-school-map',
    name: 'XiangshanSchoolMap',
    component: () => import('@/views/XiangshanSchoolMap.vue')
  },
  {
    path: '/xiangshan-talent-structure',
    name: 'XiangshanTalentStructure',
    component: () => import('@/views/XiangshanTalentStructure.vue')
  },
  {
    path: '/xiangshan-talent-atlas',
    name: 'XiangshanTalentAtlas',
    component: () => import('@/views/XiangshanTalentAtlas.vue')
  },
  {
    path: '/questionnaire-pdf',
    name: 'QuestionnairePdfViewer',
    component: () => import('@/views/QuestionnairePdfViewer.vue')
  },
  {
    path: '/clean-energy-talent-map',
    name: 'CleanEnergyTalentMap',
    component: () => import('@/views/CleanEnergyTalentMap.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router 